<template lang="pug">
  div.grey.lighten-5.py-5
    v-row()
      v-col(
        v-for="carrierInfo in list"
        :key="carrierInfo.id"
        cols="12"
        )
          DeliveryMethodCard(
            :details="carrierInfo"
            :on-delete="onDelete"
            :disable-delete="list.length === 1"
            :invalid-selection="!isCarrierInvisible && !getDeliveryProduct(carrierInfo)"
            )
</template>
<script lang="ts">
import Vue from 'vue';
import DeliveryMethodCard from 'Merchant/contract/components/contract-carrier/delivery-method-card.vue';

export default Vue.extend({
  name: 'DeliveryMethodCards',
  components: { DeliveryMethodCard },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    onDelete: {
      type: Function,
      required: true,
    },
    allowedDeliveryProducts: {
      type: Array,
      default: () => [],
    },
    isCarrierInvisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ...this.mapState({
        merchantProfile: 'flow.general.merchant.data',
      }),
    };
  },
  methods: {
    getDeliveryProduct(selection: Object) {
      return this.allowedDeliveryProducts.find(
        // @ts-ignore
        (adp) => adp.deliveryProduct.id === selection.id
      );
    },
  },
});
</script>
<style lang="scss" scoped></style>
